import api from '../services/api-caller';
import utils from '../mixins/utils';
import { getSubdomain } from '../utils/subdomain';

const { setUserInfo, setLastURL } = utils.methods;

const nonSecure = (to) => {
  return to.path == '/login'
    || to.path == '/password-recovery'
    || to.path == '/terms-of-use'
    || to.path == '/404'
    || to.path.startsWith('/new-password')
    || to.path.startsWith('/embed');
};

export default () => {
  return async (to, from, next) => {
    if (nonSecure(to)) {
      next();
      return;
    }

    try {
      const response = await api('/authz/check', null, null, null, null, true);
      const userInfo = response.body;
      const windowSubdomain = getSubdomain();

      if (userInfo.organization.subdomain != windowSubdomain) {
        throw Error('token of an organization different from that of the subdomain');
      }

      setUserInfo(userInfo);
      next();

    } catch (err) {
      setLastURL('/' + window.location.hash);
      next({ path: '/login' });
    }
  };
};
